import { Product } from '@@types'
import { TFunction } from 'i18next'

export const WEIGHT_MULTIPLIER_MG = 0
export const WEIGHT_MULTIPLIER_G = 1
export const WEIGHT_MULTIPLIER_KG = 2

export const getNearestWeightMultiplier = (product: Product) => {
  let multiplier = WEIGHT_MULTIPLIER_G

  if ((product.weight as number) > 1000) {
    multiplier = (product.weight_multiplier as number) + 1
  }

  if (multiplier > WEIGHT_MULTIPLIER_KG) {
    return WEIGHT_MULTIPLIER_KG
  }

  return multiplier
}

export const formatOrderWeight = (weight: number = 0): string => {
  if (weight >= 1000) {
    return `${parseFloat((weight / 1000).toFixed(2))} кг.`
  }
  return `${parseFloat(weight.toFixed(2))} гр.`
}

export const formatOrderWeightTranslation = (
  weight: number = 0,
  t: (key: string) => string,
): string => {
  if (weight >= 1000) {
    return `${parseFloat((weight / 1000).toFixed(2))} ${t('kg')}`
  }
  return `${parseFloat(weight.toFixed(2))} ${t('gr')}`
}

export const getWeightPostfix = (product: Product, t: TFunction) => {
  const multiplier = getNearestWeightMultiplier(product)

  switch (multiplier) {
  case WEIGHT_MULTIPLIER_G:
    return t('weight.gr')
  case WEIGHT_MULTIPLIER_KG:
    return t('weight.kg')
  default:
    return t('weight.mg')
  }
}
